import { Navigate } from "react-router-dom";

const PublicRoute = ({ children }) => {
  const user = JSON.parse(localStorage.getItem("user"));

  if (user) {
    const department = (user.department || user.usr_department || "")
      .toLowerCase()
      .replace(/[\s_-]+/g, "");

    const departmentHome =
      department === "presales" || department === "bidmanager"
        ? "/leads"
        : "/dashboard";

    return <Navigate to={departmentHome} replace />;
  }

  return children;
};

export default PublicRoute;
